import web from "../web";

class LiensParentauxService {
    index(token){
        return web.get("/api/liensparentaux", { headers: { 'Authorization': 'Bearer '+token } })
    } 

    store(data, token){
        return web.post("/api/liensparentaux", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/liensparentaux/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/liensparentaux/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/liensparentaux/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new LiensParentauxService()